// extracted by mini-css-extract-plugin
export default {"floatButton":"FloatWhatzapButton_floatButton__4cwud","float":"FloatWhatzapButton_float__dDR1e","icon":"FloatWhatzapButton_icon__Ba8n3"};